<ng-template #loadingGeneral>
  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>
</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">

  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button (click)="createBox()"
              *ngIf="!embeddedLayout && (hasPermission(loggedUser, 'admin'))"
              color="primary" mat-button>New box
      </button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>

    <table (matSortChange)="doSortBoxes($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
           matSort multiTemplateDataRows>


      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{ element.id }}</td>
      </ng-container>

      <!-- Enabled Column -->
      <ng-container matColumnDef="enabled">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Enabled</th>
        <td *matCellDef="let element" mat-cell>
          <mat-icon class="correct-color" *ngIf="element.enabled">check_circle</mat-icon>
          <mat-icon class="error-color" *ngIf="!element.enabled">cancel</mat-icon>
        </td>
      </ng-container>

      <!-- Hardware Version -->
      <ng-container matColumnDef="hardwareVersion">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>HW Version</th>
        <td *matCellDef="let element" mat-cell> {{ element.hardwareVersion }}</td>
      </ng-container>

      <!-- Identifier Column -->
      <ng-container matColumnDef="identifier">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Identifier</th>
        <td *matCellDef="let element" mat-cell>{{ element.identifier }}</td>
      </ng-container>

      <!-- Software Version Column -->
      <ng-container matColumnDef="softwareVersion">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>SW Version</th>
        <td *matCellDef="let element" mat-cell> {{ element.softwareVersion }}</td>
      </ng-container>

      <!-- Location Column -->
      <ng-container matColumnDef="server">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Server</th>
        <td *matCellDef="let element" mat-cell> {{ element?.boxLocation?.region }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="logisticsStatus">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
        <td *matCellDef="let element" mat-cell> {{ element.status | splitCamelCase }}&nbsp;
          <i (click)="statusDetails()" class="far fa-question-circle color-disabled cursor-pointer"></i>
        </td>
      </ng-container>

      <!-- Sim Column -->
      <ng-container matColumnDef="sim">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Sim</th>
        <td *matCellDef="let element" mat-cell> {{ element?.sim?.identifier }}</td>
      </ng-container>


      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" class="text-right" mat-cell>
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">

            <!--ACTIONS BUTTON-->


            <!--ICON FOR ACTION REQUIRED-->
            <ng-container *awIsInRoleAndStatusForThisEntity="[
                {permission: 'admin', status: boxStatus.assigned, entity: element},
                {permission: 'logistic', status: boxStatus.assigned, entity: element},
                {permission: 'admin', status: boxStatus.shipped, entity: element},
                {permission: 'customer', status: boxStatus.shipped, entity: element},
                {permission: 'admin', status: boxStatus.delivered, entity: element},
                {permission: 'customer', status: boxStatus.delivered, entity: element},
                {permission: 'admin', status: boxStatus.fail, entity: element},
                {permission: 'customer', status: boxStatus.fail, entity: element},
                {permission: 'admin', status: boxStatus.toShipBack, entity: element},
                {permission: 'customer', status: boxStatus.toShipBack, entity: element},
                {permission: 'admin', status: boxStatus.goingHome, entity: element},
                {permission: 'logistic', status: boxStatus.goingHome, entity: element},
              ]">
              <!--              class="fas fa-exclamation-triangle color-warn">-->
              <button (click)="dialogsService.alert('INFO',  getTooltip(element))" mat-icon-button>
                <mat-icon color="warn" [matTooltip]="getTooltip(element)">warning</mat-icon>
              </button>
            </ng-container>

            <!-- RED ICON FOR ACTION REQUIRED Done here since directives can't cross check entities and related entities -->
            <!--            <ng-container-->
            <!--              *ngIf="loggedUser.role !== roles.logistic &&-->
            <!--              (element?.contract?.status === contractStatus.ongoing-->
            <!--              || element?.contract?.status === contractStatus.extended)">-->
            <!--              &lt;!&ndash;              <i class="fas fa-exclamation-triangle color-warn"></i>&ndash;&gt;-->
            <!--              <button mat-icon-button>-->
            <!--                <mat-icon color="warn">warning</mat-icon>-->
            <!--              </button>-->
            <!--            </ng-container>-->

            <!--ICON FOR NON-MANDATORY POSSIBLE ACTION-->
            <ng-container *awIsInRoleAndStatusForThisEntity="[
                  {permission: 'admin', status: boxStatus.toBeConfigured, entity: element},
                  {permission: 'logistic', status: boxStatus.toBeConfigured, entity: element},
                  {permission: 'admin', status: boxStatus.onTheShelf, entity: element},
                  {permission: 'logistic', status: boxStatus.onTheShelf, entity: element},
                  {permission: 'admin', status: boxStatus.updating, entity: element},
                  {permission: 'logistic', status: boxStatus.updating, entity: element},
                  {permission: 'admin', status: boxStatus.broken, entity: element},
                  {permission: 'logistic', status: boxStatus.broken, entity: element},
                  {permission: 'admin', status: boxStatus.mounted, entity: element},
                  {permission: 'customer', status: boxStatus.mounted, entity: element},
                  {permission: 'admin', status: boxStatus.available, entity: element},
                  {permission: 'customer', status: boxStatus.available, entity: element},
                  {permission: 'admin', status: boxStatus.unavailable, entity: element},
                  {permission: 'customer', status: boxStatus.unavailable, entity: element},
                  {permission: 'admin', status: boxStatus.updating, entity: element},
                  {permission: 'customer', status: boxStatus.updating, entity: element}
                ]">
              <!--              class="fas fa-bell color-primary"-->
              <button (click)="dialogsService.alert('INFO',  getTooltip(element))" mat-icon-button>
                <mat-icon color="accent" [matTooltip]="getTooltip(element)">notifications</mat-icon>
              </button>
            </ng-container>

            <button [matMenuTriggerFor]="actions" mat-icon-button>
              <!--              <i class="fas fa-ellipsis-v"></i>-->
              <mat-icon>more_vert</mat-icon>
            </button>

            <p *ngIf="element.status === boxStatus.mounted && element?.contract?.status === contractStatus.boxesWaiting"
               class="mat-background-primary button-rounded text-center color-light">
              Waiting for Contract Start Date
            </p>

            <!--ACTIONS MENU-->
            <mat-menu #actions="matMenu">
              <!--              <button *awIsInRoleAndStatusForThisEntity="[-->
              <!--                  {role: roles.admin, status: boxStatus.new, entity: element},-->
              <!--                  {role: roles.logistic, status: boxStatus.new, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.onTheShelf, entity: element},-->
              <!--                  {role: roles.logistic, status: boxStatus.onTheShelf, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.broken, entity: element},-->
              <!--                  {role: roles.logistic, status: boxStatus.broken, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.toBeConfigured, entity: element},-->
              <!--                  {role: roles.logistic, status: boxStatus.toBeConfigured, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.assigned, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.assigned, entity: element},-->
              <!--                  {role: roles.logistic, status: boxStatus.assigned, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.shipped, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.shipped, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.delivered, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.delivered, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.mounted, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.mounted, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.available, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.available, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.unavailable, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.unavailable, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.inUse, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.inUse, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.updating, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.updating, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.fail, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.fail, entity: element},-->
              <!--                  {role: roles.logistic, status: boxStatus.fail, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.toShipBack, entity: element},-->
              <!--                  {role: roles.customer, status: boxStatus.toShipBack, entity: element},-->
              <!--                  {role: roles.admin, status: boxStatus.goingHome, entity: element},-->
              <!--                  {role: roles.logistic, status: boxStatus.goingHome, entity: element},-->
              <!--                ]"-->
              <!--                      mat-menu-item [matMenuTriggerFor]="management">MANAGEMENT</button>-->
              <!--              <button mat-menu-item [matMenuTriggerFor]="info">INFO</button>-->

              <!--Show details-->
              <button (click)="details(element)" [disabled]="disabled" mat-menu-item>
                <mat-icon>visibility</mat-icon>
                Show details
              </button>
              <!-- Not needed -->
              <!-- <button *ngIf="element.weseth2 == true" [disabled]="disabled" (click)="showBoxInfo(element)" mat-menu-item>
                <mat-icon>reorder</mat-icon>
                Show Weseth interfaces
              </button> -->

              <!--Expand sim-->
              <ng-container *awIsInAnyRole="['admin', 'logistic']">
                <button (click)="expandSim(element)" *ngIf="element?.sim" [disabled]="disabled" mat-menu-item>
                  <mat-icon>sim_card</mat-icon>
                  Show sim
                </button>
              </ng-container>

              <!--Expand box interfaces-->
              <ng-container *awIsInAnyRole="['admin', 'customer', 'logistic']">
                <button (click)="expandBoxInterfaces(element)" *ngIf="element?.boxInterfaces?.length !== 0"
                        [disabled]="disabled" mat-menu-item>
                  <mat-icon>laptop_windows</mat-icon>
                  Show box interfaces
                </button>
              </ng-container>

              <!--Expand researchers-->
              <ng-container *awIsInAnyRole="['admin', 'customer']">
                <button mat-menu-item *ngIf="element?.researchers?.length !== 0" (click)="expandResearchers(element)"
                        [disabled]="disabled">
                  <mat-icon>people</mat-icon>
                  Show researchers
                </button>
              </ng-container>

              <!--Expand history-->
              <button (click)="expandEvents(element)" *awIsInAnyRole="['admin', 'customer', 'logistic']"
                      [disabled]="disabled" mat-menu-item>
                <mat-icon>history</mat-icon>
                View box history
              </button>

              <!--Change status-->
              <ng-container *awIsInRoleAndStatusForThisEntity="[
                  {permission: 'admin', status: boxStatus.new, entity: element},
                  {permission: 'logistic', status: boxStatus.new, entity: element},
                  {permission: 'admin', status: boxStatus.onTheShelf, entity: element},
                  {permission: 'logistic', status: boxStatus.onTheShelf, entity: element},
                  {permission: 'admin', status: boxStatus.broken, entity: element},
                  {permission: 'logistic', status: boxStatus.broken, entity: element},
                  {permission: 'admin', status: boxStatus.toBeConfigured, entity: element},
                  {permission: 'logistic', status: boxStatus.toBeConfigured, entity: element},
                  {permission: 'admin', status: boxStatus.assigned, entity: element},
                  {permission: 'logistic', status: boxStatus.assigned, entity: element},
                  {permission: 'admin', status: boxStatus.shipped, entity: element},
                  {permission: 'customer', status: boxStatus.shipped, entity: element},
                  {permission: 'admin', status: boxStatus.delivered, entity: element},
                  {permission: 'customer', status: boxStatus.delivered, entity: element},
                  {permission: 'admin', status: boxStatus.mounted, entity: element},
                  {permission: 'customer', status: boxStatus.mounted, entity: element},
                  {permission: 'admin', status: boxStatus.available, entity: element},
                  {permission: 'customer', status: boxStatus.available, entity: element},
                  {permission: 'admin', status: boxStatus.unavailable, entity: element},
                  {permission: 'customer', status: boxStatus.unavailable, entity: element},
                  {permission: 'admin', status: boxStatus.inUse, entity: element},
                  {permission: 'customer', status: boxStatus.inUse, entity: element},
                  {permission: 'admin', status: boxStatus.updating, entity: element},
                  {permission: 'customer', status: boxStatus.updating, entity: element},
                  {permission: 'admin', status: boxStatus.fail, entity: element},
                  {permission: 'customer', status: boxStatus.fail, entity: element},
                  {permission: 'admin', status: boxStatus.toShipBack, entity: element},
                  {permission: 'customer', status: boxStatus.toShipBack, entity: element},
                  {permission: 'admin', status: boxStatus.goingHome, entity: element},
                  {permission: 'logistic', status: boxStatus.goingHome, entity: element},
                ]">
                <!--Se la box non è mounted e il contratto NON è boxesWaiting, mostra -->
                <!-- *ngIf="(element.status !== boxStatus.mounted) || (element.status === boxStatus.mounted && (element?.contract?.status === contractStatus.ongoing || element?.contract?.status === contractStatus.extended))" -->
                <button (click)="performAction(element, false)" mat-menu-item>
                  <mat-icon color="primary">new_releases</mat-icon>
                  Change status
                </button>
              </ng-container>

              <!--Enable box-->
              <ng-container *awIsInAnyRole="['admin']">
                <button (click)="performAction(element, true)" *ngIf="!element.enabled" [disabled]="disabled"
                        mat-menu-item>
                  <mat-icon>settings_power</mat-icon>
                  Enable box
                </button>
              </ng-container>

              <!--Disable box-->
              <ng-container *awIsInAnyRole="['admin']">
                <button (click)="performAction(element, true)" *ngIf="element.enabled" [disabled]="disabled"
                        mat-menu-item>
                  <mat-icon color="primary">settings_power</mat-icon>
                  Disable box
                </button>
              </ng-container>

              <!--Assign sim-->
              <button (click)="assignSim(element)" *awIsInRoleAndStatusForThisEntity="[
                         {permission: 'admin', status: boxStatus.onTheShelf, entity: element},
                         {permission: 'logistic', status: boxStatus.onTheShelf, entity: element},
                         {permission: 'admin', status: boxStatus.toBeConfigured, entity: element},
                         {permission: 'logistic', status: boxStatus.toBeConfigured, entity: element},
                         {permission: 'admin', status: boxStatus.assigned, entity: element},
                         {permission: 'logistic', status: boxStatus.assigned, entity: element},
                         {permission: 'admin', status: boxStatus.delivered, entity: element},
                         {permission: 'logistic', status: boxStatus.delivered, entity: element},
                         {permission: 'admin', status: boxStatus.mounted, entity: element},
                         {permission: 'logistic', status: boxStatus.mounted, entity: element},
                         {permission: 'admin', status: boxStatus.available, entity: element},
                         {permission: 'logistic', status: boxStatus.available, entity: element},
                         {permission: 'admin', status: boxStatus.unavailable, entity: element},
                         {permission: 'logistic', status: boxStatus.unavailable, entity: element},
                         {permission: 'admin', status: boxStatus.updating, entity: element},
                         {permission: 'logistic', status: boxStatus.updating, entity: element},
                       ]" [disabled]="disabled" mat-menu-item>
                <mat-icon>sim_card</mat-icon>
                <ng-container *ngIf="element.sim">
                  Change sim
                </ng-container>
                <ng-container *ngIf="!element.sim">
                  Add sim
                </ng-container>
              </button>

              <!--Remove sim-->
              <ng-container *ngIf="element.sim">
                <button (click)="removeSim(element)" *awIsInRoleAndStatusForThisEntity="[
                           {permission: 'admin', status: boxStatus.onTheShelf, entity: element},
                           {permission: 'logistic', status: boxStatus.onTheShelf, entity: element},
                           {permission: 'admin', status: boxStatus.toBeConfigured, entity: element},
                           {permission: 'logistic', status: boxStatus.toBeConfigured, entity: element},
                           {permission: 'admin', status: boxStatus.assigned, entity: element},
                           {permission: 'logistic', status: boxStatus.assigned, entity: element},
                           {permission: 'admin', status: boxStatus.delivered, entity: element},
                           {permission: 'logistic', status: boxStatus.delivered, entity: element},
                           {permission: 'admin', status: boxStatus.mounted, entity: element},
                           {permission: 'logistic', status: boxStatus.mounted, entity: element},
                           {permission: 'admin', status: boxStatus.available, entity: element},
                           {permission: 'logistic', status: boxStatus.available, entity: element},
                           {permission: 'admin', status: boxStatus.unavailable, entity: element},
                           {permission: 'logistic', status: boxStatus.unavailable, entity: element},
                           {permission: 'admin', status: boxStatus.updating, entity: element},
                           {permission: 'logistic', status: boxStatus.updating, entity: element},
                         ]" [disabled]="disabled" mat-menu-item>
                  <mat-icon>no_sim</mat-icon>
                  Remove sim
                </button>
              </ng-container>

              <!--Assign box interfaces-->
              <ng-container *awIsInAnyRole="['admin', 'logistic']">
                <button (click)="addBoxInterfaces(element)" [disabled]="disabled" mat-menu-item>
                  <mat-icon>queue_play_next</mat-icon>
                  Add box interfaces
                </button>
              </ng-container>


              <!--Assign researchers-->
              <button (click)="addResearchers(element)" *awIsInRoleAndStatusForThisEntity="[
                        {permission: 'admin', status: boxStatus.assigned, entity: element},
                        {permission: 'customer', status: boxStatus.assigned, entity: element},
                        {permission: 'admin', status: boxStatus.shipped, entity: element},
                        {permission: 'customer', status: boxStatus.shipped, entity: element},
                        {permission: 'admin', status: boxStatus.delivered, entity: element},
                        {permission: 'customer', status: boxStatus.delivered, entity: element},
                        {permission: 'admin', status: boxStatus.mounted, entity: element},
                        {permission: 'customer', status: boxStatus.mounted, entity: element},
                        {permission: 'admin', status: boxStatus.available, entity: element},
                        {permission: 'customer', status: boxStatus.available, entity: element},
                        {permission: 'admin', status: boxStatus.unavailable, entity: element},
                        {permission: 'customer', status: boxStatus.unavailable, entity: element},
                        {permission: 'admin', status: boxStatus.inUse, entity: element},
                        {permission: 'customer', status: boxStatus.inUse, entity: element},
                        {permission: 'admin', status: boxStatus.updating, entity: element},
                        {permission: 'customer', status: boxStatus.updating, entity: element},
                      ]" [disabled]="disabled" mat-menu-item>
                <mat-icon>person_add</mat-icon>
                Assign researchers
              </button>

              <!--Region NOT EMBEDDED-->
              <ng-container *ngIf="!embeddedLayout">

                <!--EDIT-->
                <button (click)="editBox(element)" *awIsInAnyRole="['admin', 'logistic']" [disabled]="disabled"
                        mat-menu-item>
                  <mat-icon>edit</mat-icon>
                  Edit box
                </button>

                <!--DELETE-->
                <button (click)="deleteBox(element)" *awIsInRoleAndStatusForThisEntity="[
                          {permission: 'admin', status: boxStatus.onTheShelf, entity: element},
                          {permission: 'admin', status: boxStatus.toBeConfigured, entity: element},
                          {permission: 'admin', status: boxStatus.broken, entity: element}
                        ]" [disabled]="disabled" mat-menu-item>
                  <mat-icon>delete</mat-icon>
                  Delete box
                </button>
              </ng-container>
              <!--END Region NOT EMBEDDED-->

              <button (click)="assignSim(element)" *awIsInRoleAndStatusForThisEntity="[
                         {permission: 'admin', status: boxStatus.onTheShelf, entity: element},
                         {permission: 'logistic', status: boxStatus.onTheShelf, entity: element},
                         {permission: 'admin', status: boxStatus.toBeConfigured, entity: element},
                         {permission: 'logistic', status: boxStatus.toBeConfigured, entity: element},
                         {permission: 'admin', status: boxStatus.assigned, entity: element},
                         {permission: 'logistic', status: boxStatus.assigned, entity: element},
                         {permission: 'admin', status: boxStatus.delivered, entity: element},
                         {permission: 'logistic', status: boxStatus.delivered, entity: element},
                         {permission: 'admin', status: boxStatus.mounted, entity: element},
                         {permission: 'logistic', status: boxStatus.mounted, entity: element},
                         {permission: 'admin', status: boxStatus.available, entity: element},
                         {permission: 'logistic', status: boxStatus.available, entity: element},
                         {permission: 'admin', status: boxStatus.unavailable, entity: element},
                         {permission: 'logistic', status: boxStatus.unavailable, entity: element},
                         {permission: 'admin', status: boxStatus.updating, entity: element},
                         {permission: 'logistic', status: boxStatus.updating, entity: element},
                       ]"
                      [disabled]="disabled"
                      mat-menu-item>
                <mat-icon>sim_card</mat-icon>
                <ng-container *ngIf="element.sim">
                  Change sim
                </ng-container>
                <ng-container *ngIf="!element.sim">
                  Add sim
                </ng-container>
              </button>

            </mat-menu>

            <!--*** INFO MENU ***-->
            <!--            <mat-menu #info="matMenu">-->

            <!--              &lt;!&ndash;Show details&ndash;&gt;-->
            <!--              <button (click)="details(element)" [disabled]="disabled" mat-menu-item>-->
            <!--                <mat-icon>visibility</mat-icon>-->
            <!--                Show details-->
            <!--              </button>-->

            <!--              &lt;!&ndash;Expand sim&ndash;&gt;-->
            <!--              <ng-container *awIsInAnyRole="[roles.admin, roles.logistic]">-->
            <!--                <button (click)="expandSim(element)"-->
            <!--                        *ngIf="element?.sim"-->
            <!--                        [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>sim_card</mat-icon>-->
            <!--                  Show sim-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Expand box interfaces&ndash;&gt;-->
            <!--              <ng-container *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic]">-->
            <!--                <button (click)="expandBoxInterfaces(element)" *ngIf="element?.boxInterfaces?.length !== 0"-->
            <!--                        [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>laptop_windows</mat-icon>-->
            <!--                  Show box interfaces-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Expand researchers&ndash;&gt;-->
            <!--              <ng-container *awIsInAnyRole="[roles.admin, roles.customer]">-->
            <!--                <button mat-menu-item-->
            <!--                        *ngIf="element?.researchers?.length !== 0"-->
            <!--                        (click)="expandResearchers(element)"-->
            <!--                        [disabled]="disabled">-->
            <!--                  <mat-icon>people</mat-icon>-->
            <!--                  Show researchers-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Expand certificate&ndash;&gt;-->
            <!--              <ng-container *ngIf="element?.currentCertificate">-->
            <!--                <button (click)="expandCertificates(element)"-->
            <!--                        *awIsInAnyRole="[roles.admin, roles.logistic, roles.customer]"-->
            <!--                        [disabled]="disabled" mat-menu-item>-->
            <!--                  <mat-icon>task</mat-icon>-->
            <!--                  Show box certificate-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Expand history&ndash;&gt;-->
            <!--              <button (click)="expandEvents(element)" *awIsInAnyRole="[roles.admin, roles.customer, roles.logistic]"-->
            <!--                      [disabled]="disabled"-->
            <!--                      mat-menu-item>-->
            <!--                <mat-icon>history</mat-icon>-->
            <!--                View box history-->
            <!--              </button>-->

            <!--            </mat-menu>-->

            <!--*** MANAGEMENT MENU ***-->
            <!--            <mat-menu #management="matMenu">-->

            <!--              &lt;!&ndash;Change status&ndash;&gt;-->
            <!--              <ng-container-->
            <!--                *awIsInRoleAndStatusForThisEntity="[-->
            <!--                  {role: roles.admin, status: boxStatus.new, entity: element},-->
            <!--                  {role: roles.logistic, status: boxStatus.new, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.onTheShelf, entity: element},-->
            <!--                  {role: roles.logistic, status: boxStatus.onTheShelf, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.broken, entity: element},-->
            <!--                  {role: roles.logistic, status: boxStatus.broken, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.toBeConfigured, entity: element},-->
            <!--                  {role: roles.logistic, status: boxStatus.toBeConfigured, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.assigned, entity: element},-->
            <!--                  {role: roles.logistic, status: boxStatus.assigned, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.shipped, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.shipped, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.delivered, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.delivered, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.mounted, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.mounted, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.available, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.available, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.unavailable, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.unavailable, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.inUse, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.inUse, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.updating, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.updating, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.fail, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.fail, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.toShipBack, entity: element},-->
            <!--                  {role: roles.customer, status: boxStatus.toShipBack, entity: element},-->
            <!--                  {role: roles.admin, status: boxStatus.goingHome, entity: element},-->
            <!--                  {role: roles.logistic, status: boxStatus.goingHome, entity: element},-->
            <!--                ]">-->
            <!--                &lt;!&ndash;Se la box non è mounted e il contratto NON è boxesWaiting, mostra &ndash;&gt;-->
            <!--                <button *ngIf="(element.status !== boxStatus.mounted) || (element.status === boxStatus.mounted && (element?.contract?.status === contractStatus.ongoing || element?.contract?.status === contractStatus.extended))"-->
            <!--                  (click)="performAction(element, false)"-->

            <!--                  mat-menu-item>-->
            <!--                  <mat-icon color="primary">new_releases</mat-icon>-->
            <!--                  Change status-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Enable box&ndash;&gt;-->
            <!--              <ng-container *awIsInAnyRole="[roles.admin]">-->
            <!--                <button (click)="performAction(element, true)" *ngIf="!element.enabled" [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>settings_power</mat-icon>-->
            <!--                  Enable box-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Disable box&ndash;&gt;-->
            <!--              <ng-container *awIsInAnyRole="[roles.admin]">-->
            <!--                <button (click)="performAction(element, true)" *ngIf="element.enabled" [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon color="primary">settings_power</mat-icon>-->
            <!--                  Disable box-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Assign sim&ndash;&gt;-->
            <!--              <button (click)="assignSim(element)" *awIsInRoleAndStatusForThisEntity="[-->
            <!--                         {role: roles.admin, status: boxStatus.onTheShelf, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.onTheShelf, entity: element},-->
            <!--                         {role: roles.admin, status: boxStatus.toBeConfigured, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.toBeConfigured, entity: element},-->
            <!--                         {role: roles.admin, status: boxStatus.assigned, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.assigned, entity: element},-->
            <!--                         {role: roles.admin, status: boxStatus.delivered, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.delivered, entity: element},-->
            <!--                         {role: roles.admin, status: boxStatus.mounted, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.mounted, entity: element},-->
            <!--                         {role: roles.admin, status: boxStatus.available, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.available, entity: element},-->
            <!--                         {role: roles.admin, status: boxStatus.unavailable, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.unavailable, entity: element},-->
            <!--                         {role: roles.admin, status: boxStatus.updating, entity: element},-->
            <!--                         {role: roles.logistic, status: boxStatus.updating, entity: element},-->
            <!--                       ]"-->
            <!--                      [disabled]="disabled"-->
            <!--                      mat-menu-item>-->
            <!--                <mat-icon>sim_card</mat-icon>-->
            <!--                <ng-container *ngIf="element.sim">-->
            <!--                  Change sim-->
            <!--                </ng-container>-->
            <!--                <ng-container *ngIf="!element.sim">-->
            <!--                  Add sim-->
            <!--                </ng-container>-->
            <!--              </button>-->

            <!--              &lt;!&ndash;Remove sim&ndash;&gt;-->
            <!--              <ng-container *ngIf="element.sim">-->
            <!--                <button (click)="removeSim(element)"-->
            <!--                        *awIsInRoleAndStatusForThisEntity="[-->
            <!--                           {role: roles.admin, status: boxStatus.onTheShelf, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.onTheShelf, entity: element},-->
            <!--                           {role: roles.admin, status: boxStatus.toBeConfigured, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.toBeConfigured, entity: element},-->
            <!--                           {role: roles.admin, status: boxStatus.assigned, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.assigned, entity: element},-->
            <!--                           {role: roles.admin, status: boxStatus.delivered, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.delivered, entity: element},-->
            <!--                           {role: roles.admin, status: boxStatus.mounted, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.mounted, entity: element},-->
            <!--                           {role: roles.admin, status: boxStatus.available, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.available, entity: element},-->
            <!--                           {role: roles.admin, status: boxStatus.unavailable, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.unavailable, entity: element},-->
            <!--                           {role: roles.admin, status: boxStatus.updating, entity: element},-->
            <!--                           {role: roles.logistic, status: boxStatus.updating, entity: element},-->
            <!--                         ]"-->
            <!--                        [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>no_sim</mat-icon>-->
            <!--                  Remove sim-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Assign box interfaces&ndash;&gt;-->
            <!--              <ng-container *awIsInAnyRole="[roles.admin, roles.logistic]">-->
            <!--                <button (click)="addBoxInterfaces(element)" [disabled]="disabled" mat-menu-item>-->
            <!--                  <mat-icon>queue_play_next</mat-icon>-->
            <!--                  Add box interfaces-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Assign certificate&ndash;&gt;-->
            <!--              <ng-container *ngIf="!element.currentCertificate">-->
            <!--                <button (click)="addCertificate(element)" *awIsInAnyRole="[roles.admin, roles.logistic]"-->
            <!--                        [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>note_add</mat-icon>-->
            <!--                  Assign box certificate-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Remove certificate&ndash;&gt;-->
            <!--              <ng-container *ngIf="element.currentCertificate">-->
            <!--                <button (click)="removeCertificate(element)"-->
            <!--                        *awIsInAnyRole="[roles.admin]"-->
            <!--                        [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>block</mat-icon>-->
            <!--                  Remove certificate-->
            <!--                </button>-->
            <!--              </ng-container>-->

            <!--              &lt;!&ndash;Assign researchers&ndash;&gt;-->
            <!--              <button (click)="addResearchers(element)"-->
            <!--                      *awIsInRoleAndStatusForThisEntity="[-->
            <!--                        {role: roles.admin, status: boxStatus.assigned, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.assigned, entity: element},-->
            <!--                        {role: roles.admin, status: boxStatus.shipped, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.shipped, entity: element},-->
            <!--                        {role: roles.admin, status: boxStatus.delivered, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.delivered, entity: element},-->
            <!--                        {role: roles.admin, status: boxStatus.mounted, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.mounted, entity: element},-->
            <!--                        {role: roles.admin, status: boxStatus.available, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.available, entity: element},-->
            <!--                        {role: roles.admin, status: boxStatus.unavailable, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.unavailable, entity: element},-->
            <!--                        {role: roles.admin, status: boxStatus.inUse, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.inUse, entity: element},-->
            <!--                        {role: roles.admin, status: boxStatus.updating, entity: element},-->
            <!--                        {role: roles.customer, status: boxStatus.updating, entity: element},-->
            <!--                      ]"-->
            <!--                      [disabled]="disabled"-->
            <!--                      mat-menu-item>-->
            <!--                <mat-icon>person_add</mat-icon>-->
            <!--                Assign researchers-->
            <!--              </button>-->

            <!--              &lt;!&ndash;Region NOT EMBEDDED&ndash;&gt;-->
            <!--              <ng-container *ngIf="!embeddedLayout">-->

            <!--                &lt;!&ndash;EDIT&ndash;&gt;-->
            <!--                <button (click)="editBox(element)" *awIsInAnyRole="[roles.admin, roles.logistic]" [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>edit</mat-icon>-->
            <!--                  Edit box-->
            <!--                </button>-->

            <!--                &lt;!&ndash;DELETE&ndash;&gt;-->
            <!--                <button (click)="deleteBox(element)"-->
            <!--                        *awIsInRoleAndStatusForThisEntity="[-->
            <!--                          {role: roles.admin, status: boxStatus.onTheShelf, entity: element},-->
            <!--                          {role: roles.admin, status: boxStatus.toBeConfigured, entity: element},-->
            <!--                          {role: roles.admin, status: boxStatus.broken, entity: element}-->
            <!--                        ]"-->
            <!--                        [disabled]="disabled"-->
            <!--                        mat-menu-item>-->
            <!--                  <mat-icon>delete</mat-icon>-->
            <!--                  Delete box-->
            <!--                </button>-->
            <!--              </ng-container>-->
            <!--              &lt;!&ndash;END Region NOT EMBEDDED&ndash;&gt;-->

            <!--            </mat-menu>-->

          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="expandedResearchers">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>

          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Associated Researchers</h3>
            <button (click)="expandedResearchers = undefined" mat-button>Close</button>
          </div>
          <aw-list-users *ngIf="expandedResearchers?.id == element.id" type="researchersByBox"
                         [filterByBox]="element" [embeddedLayout]="true"
                         [deleteAction]="{enabled: true, action: deleteUserAction(element)}"
          >
          </aw-list-users>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedSim">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Associated Sim</h3>
            <button (click)="expandedSim = undefined" mat-button>Close</button>
          </div>
          <aw-list-sims *ngIf="expandedSim?.id == element.id" [box]="element" [embeddedLayout]="true"></aw-list-sims>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedBoxEventsHistory">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Events history</h3>
            <button (click)="expandedBoxEventsHistory = undefined" mat-button>Close</button>
          </div>
          <aw-list-box-events *ngIf="expandedBoxEventsHistory?.id == element.id" [box]="element" [contract]="contract"
                              [embeddedLayout]="true"></aw-list-box-events>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedInterfaces">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Box Interfaces</h3>
            <button (click)="expandedInterfaces = undefined" mat-button>Close</button>
          </div>
          <aw-list-box-interfaces *ngIf="expandedInterfaces?.id == element.id" [box]="element" [embeddedLayout]="true">
          </aw-list-box-interfaces>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <tr *matRowDef="let row; columns: ['expandedBoxEventsHistory']" [fxShow]="expandedBoxEventsHistory?.id === row.id"
          mat-row></tr>
      <tr *matRowDef="let row; columns: ['expandedResearchers']" [fxShow]="expandedResearchers?.id === row.id" mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedInterfaces']" [fxShow]="expandedInterfaces?.id === row.id" mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedSim']" [fxShow]="expandedSim?.id === row.id" mat-row></tr>


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No boxes found
        </td>
      </tr>

    </table>


  </ng-container>

  <mat-paginator #paginatorBoxes [fxShow]="dataSource && dataSource.data.length > 10" [pageSizeOptions]="[5, 10, 20]"
                 [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>

</div>
